<ng-container *ngIf="categories?.length">
  <nav mat-tab-nav-bar class="scrollable-chips">
    <a
      *ngFor="let category of categories"
      mat-tab-link
      [ngClass]="{ active: category.categoryId === filterConfig.category }"
      (click)="applyCategory.emit(category.categoryId)"
      >{{ category.description || "N.A." }}</a
    >
  </nav>
</ng-container>
